import { Col, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { ResourceLimitationPeriodsListQuery } from '@/core/domain/enterprise/ResourceLimitationPeriods/ResourceLimitationPeriods.types';
import { InputText } from '@/components/_common';

export default function CompanyResourceLimitationPeriodsExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ResourceLimitationPeriodsListQuery>) {
  return (
    <Row gutter={[16, 16]} align="middle">
      <Col span={24} md={12} lg={6}>
        <InputText
          onlyNumber
          value={
            queryParams?.resources ? String(queryParams?.resources) : undefined
          }
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({
              ...prev,
              resources: value ? Number(value) : undefined,
            }))
          }
          placeholder="Qtde. recurso indisponivel"
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}
